import styled from "styled-components";
import { Box, Typography, Link } from "@mui/material";

export const DropTargetContainer = styled(Box)`
  display: inline-flex;
  position: fixed;
  bottom: 8%;
  left: 50%;
  align-items: center;
  background: #ffffff;
  border-radius: 999px;
  padding: 16px 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  font-size: 14px;
  font-family: 'Manrope', sans-serif;
  gap: 8px;
`;

export const DropText = styled(Typography)`
  color: #555;
  margin-right: 8px;
  font-size: 14px;
  font-weight: 600;
  font-style: semi-bold;
`;

export const DropLink = styled(Link)`
  font-weight: 500;
  color: #3a74c8;
  cursor: pointer;
  font-size: 14px;
  gap: 6px;
  display: inline-flex;
  align-items: center;
`;
